// extracted by mini-css-extract-plugin
export default {"secondary-column-cell":"secondary-column-cell_P3ZH1","secondaryColumnCell":"secondary-column-cell_P3ZH1","name":"name_VL3P_"};